import './coreRuntimeSetup'; // CoreRuntime ядра — инициализировать ДО первого рендера
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';

// Apply Telegram theme colors
if (window.Telegram?.WebApp) {
  const tg = window.Telegram.WebApp;
  document.documentElement.style.setProperty(
    '--tg-theme-bg-color',
    tg.backgroundColor
  );
  document.documentElement.style.setProperty(
    '--tg-theme-text-color',
    tg.textColor
  );
  document.documentElement.style.setProperty(
    '--tg-theme-hint-color',
    tg.hintColor
  );
  document.documentElement.style.setProperty(
    '--tg-theme-link-color',
    tg.linkColor
  );
  document.documentElement.style.setProperty(
    '--tg-theme-button-color',
    tg.buttonColor
  );
  document.documentElement.style.setProperty(
    '--tg-theme-button-text-color',
    tg.buttonTextColor
  );
  document.documentElement.style.setProperty(
    '--tg-theme-secondary-bg-color',
    tg.secondaryBackgroundColor
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);


